import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/Article";
import Category from "@/pages/Category";
import Listing from "@/pages/Listing";
import ContentPage from "@/pages/ContentPage";
import NotFound from "@/pages/NotFound";
import AuthCallback from "@/admin/AuthCallback";
import AdminGuard from "@/admin/AdminGuard";
import Login from "@/admin/Login";
import Dashboard from "@/admin/Dashboard";
import Articles from "@/admin/Articles";
import ArticleEditor from "@/admin/ArticleEditor";
import Automations from "@/admin/Automations";
import Sources from "@/admin/Sources";
import Categories from "@/admin/Categories";
import Activity from "@/admin/Activity";
import Settings from "@/admin/Settings";
import SeoSettings from "@/admin/SeoSettings";
import Pages from "@/admin/Pages";
import PageEditor from "@/admin/PageEditor";
import TrackingCodes from "@/admin/TrackingCodes";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/noticia/:slug" element={<ArticlePage />} />
        <Route path="/seccion/:slug" element={<Category />} />
        <Route path="/tema/:tag" element={<Listing mode="tag" />} />
        <Route path="/buscar" element={<Listing mode="search" />} />
        <Route path="/:slug" element={<ContentPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<AdminGuard />}>
        <Route index element={<Dashboard />} />
        <Route path="noticias" element={<Articles />} />
        <Route path="noticias/:id" element={<ArticleEditor />} />
        <Route path="automatizaciones" element={<Automations />} />
        <Route path="fuentes" element={<Sources />} />
        <Route path="secciones" element={<Categories />} />
        <Route path="paginas" element={<Pages />} />
        <Route path="paginas/:id" element={<PageEditor />} />
        <Route path="codigos" element={<TrackingCodes />} />
        <Route path="seo" element={<SeoSettings />} />
        <Route path="actividad" element={<Activity />} />
        <Route path="ajustes" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
